import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
const USE_FUNCTIONS_EMULATOR = String(process.env.VUE_APP_USE_FUNCTIONS_EMULATOR || '').trim().toLowerCase() === 'true';

const firebaseConfig = {
  apiKey: "AIzaSyC6i6xM6xtEYTRd8sTJJDNDoMtx0BjOQ78",
  authDomain: "asador-1293f.firebaseapp.com",
  projectId: "asador-1293f",
  storageBucket: "asador-1293f.appspot.com",
  messagingSenderId: "397651862944",
  appId: "1:397651862944:web:ed818145e5e0c766adf0c5",
  measurementId: "G-VXJB40CK9E"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);

if (USE_FUNCTIONS_EMULATOR) {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export { app, db, auth, functions };
